import React from "react";
import { useSelector } from "react-redux";
import CardPaymentBanner from "../cardPaymentBanner/CardPaymentBanner";
import IntervendPromoModal from "./IntervendPromoModal/IntervendPromoModal";
import MyWashAppPromoModal from "./MyWashAppPromoModal/MyWashAppPromoModal";

const BannerContainer = () => {
  const user = useSelector((state) => state.auth.user);
  const banners = user?.banners || {};

  // Fallback: if banners not yet populated, use legacy showAd for cardPayment
  const showCardPayment = banners.cardPayment ?? user?.showAd;

  return (
    <>
      {showCardPayment && <CardPaymentBanner />}
      {banners.intervend && <IntervendPromoModal />}
      {banners.mywash && <MyWashAppPromoModal />}
    </>
  );
};

export default BannerContainer;
